import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChange } from '../services/auth';
import { Loading } from './ui';

export default function RequireAuth({ children }) {
  const [user, setUser] = useState(undefined); // undefined = still checking

  useEffect(() => {
    const unsubscribe = onAuthStateChange((firebaseUser) => setUser(firebaseUser));
    return unsubscribe;
  }, []);

  if (user === undefined) return <Loading label="Checking your session…" />;
  if (!user) return <Navigate to="/login" replace />;

  return children;
}
